import { combineReducers } from 'redux';
import {
  APPS2_REQUEST,
  APPS2_SUCCESS,
  APPS2_FAILURE,
  APPS2_MAKE_INVALIDATE,
} from 'app/actions/apps/apps';

import {
  SUB_STOP_REQUEST,
  SUB_STOP_SUCCESS,
  SUB_STOP_FAILURE,
  SUB_PAUSE_RESUME_REQUEST,
  SUB_PAUSE_RESUME_SUCCESS,
  SUB_PAUSE_RESUME_FAILURE,
  SUB_EDIT_REQUEST,
  SUB_EDIT_SUCCESS,
  SUB_EDIT_FAILURE,
} from 'app/actions/apps/subs';

import {
  SUB_PAY_REQUEST,
  SUB_PAY_SUCCESS,
  SUB_PAY_FAILURE,
  SUB_RESET_NOT_ENOUGH,
} from 'app/actions/apps/subs/pay';

import {
  SUB_PREPAYD_REQUEST,
  SUB_PREPAYD_SUCCESS,
  SUB_PREPAYD_FAILURE,
} from 'app/actions/apps/subs/prepayd';

import {
  APP_SUBSCRIBE_REQUEST,
  APP_SUBSCRIBE_SUCCESS,
  APP_SUBSCRIBE_FAILURE,
} from 'app/actions/apps/subscribe';

import {
  SUBSCRIBE_BUNDLE_REQUEST,
  SUBSCRIBE_BUNDLE_SUCCESS,
  SUBSCRIBE_BUNDLE_FAILURE,
} from 'app/actions/apps/subs/bundle';

import apps from './apps';
import subs from './subs';
import tariffs from './tariffs';
import tariffBundles from './tariffBundles';


const defaultState = {
  loading: true,
  didInvalidate: true,
  stopping: false,
  pausingResuming: false,
  subscribing: false,
  saving: false,
  paying: false,
  bundleSubscribing: false,
  isNotEnoughWhilePay: false,
};


const opts = (state = defaultState, action) => {
  switch (action.type) {
    case APPS2_MAKE_INVALIDATE: {
      return { ...state, didInvalidate: true };
    }

    case APPS2_REQUEST: {
      return { ...state, loading: true };
    }

    case APPS2_SUCCESS: {
      return { ...state, loading: false, didInvalidate: false, expired: action.payload.expired };
    }
    case APPS2_FAILURE: {
      return { ...state, loading: false, didInvalidate: false };
    }

    case SUB_STOP_REQUEST: {
      return { ...state, stopping: true };
    }

    case SUB_STOP_SUCCESS:
    case SUB_STOP_FAILURE: {
      return { ...state, stopping: false };
    }

    case SUB_PAUSE_RESUME_REQUEST: {
      return { ...state, pausingResuming: true };
    }

    case SUB_PAUSE_RESUME_SUCCESS:
    case SUB_PAUSE_RESUME_FAILURE: {
      return { ...state, pausingResuming: false };
    }

    case APP_SUBSCRIBE_REQUEST: {
      return { ...state, subscribing: true };
    }

    case APP_SUBSCRIBE_SUCCESS:
    case APP_SUBSCRIBE_FAILURE: {
      return { ...state, subscribing: false };
    }

    case SUB_PREPAYD_REQUEST:
    case SUB_PAY_REQUEST: {
      return { ...state, paying: true };
    }

    case SUB_PREPAYD_SUCCESS:
    case SUB_PAY_SUCCESS: {
      return { ...state, paying: false };
    }

    case SUB_PREPAYD_FAILURE:
    case SUB_PAY_FAILURE: {
      if (action.payload.errCode === 403) {
        return { ...state, paying: false, isNotEnoughWhilePay: true };
      }
      return { ...state, paying: false };
    }

    case SUB_EDIT_REQUEST: {
      return { ...state, saving: true };
    }

    case SUB_EDIT_SUCCESS:
    case SUB_EDIT_FAILURE: {
      return { ...state, saving: false };
    }

    case SUBSCRIBE_BUNDLE_REQUEST: {
      return { ...state, bundleSubscribing: true };
    }

    case SUBSCRIBE_BUNDLE_SUCCESS:
    case SUBSCRIBE_BUNDLE_FAILURE: {
      return { ...state, bundleSubscribing: false };
    }

    case SUB_RESET_NOT_ENOUGH: {
      return { ...state, isNotEnoughWhilePay: false };
    }

    default:
  }

  return state;
};


export default combineReducers({
  data: apps,
  subs,
  opts,
  tariffs,
  tariffBundles,
});
